<template>
  <b-modal
    v-model="isShow"
    :centered="true"
    :title="title"
    :cancel-title="cancelTitle"
    :ok-title="okTitle"
    @ok="modalOk"
    @cancel="modalCancel"
    @close="modalClose"
  >
    <p class="my-4" style="overflow:auto">{{message}}</p>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      message: "default message",
      title: "Confirm",
      cancelTitle: "取消",
      okTitle: "确定",
      ok: null,
      cancel: null,
      close: null
    };
  },
  methods: {
    modalOk() {
      if (this.ok) this.ok();
    },
    modalCancel() {
      if (this.cancel) this.cancel();
    },
    modalClose() {
      if (this.close) this.close();
    }
  }
};
</script>